import APIService from '@/services/APIService';

export default {
  /**
   * Получение категорий
   *
   * @returns {*}
   */
  getCategories(model = 'task') {
    return APIService.get(`/categories/${model}`);
  },

  createCategory(data) {
    return APIService.post('/category', data);
  },

  updateCategory(categoryId, data) {
    return APIService.put(`/category/${categoryId}`, data);
  },

  deleteCategory(categoryId) {
    return APIService.delete(`/category/${categoryId}`);
  },

  bindItemsToCategory(categoryId, model = 'task', items = []) {
    const data = {
      model: {
        ids: items,
        name: model,
      },
    };
    return APIService.post(`/category/${categoryId}/relations`, data);
  },

  unbindItemsFromCategory(categoryId, model = 'task', items = []) {
    const data = {
      model: {
        ids: items,
        name: model,
      },
    };
    return APIService.post(`/category/${categoryId}/detach-relations`, data);
  },
};
